import React from "react";
import { useNavigate } from "react-router-dom";
import { useBrand } from "../../context/BrandContext";
import { apiUrl } from "../../config/config";

const Hero = () => {
  const navigate = useNavigate();
  const { brandData, loading } = useBrand();

  const bannerImage = brandData?.settings?.banner?.image
    ? `${apiUrl}/storage/${brandData.settings.banner.image}`
    : "";

  return (
    <section className="relative w-full overflow-hidden">
      {loading ? (
        <div className="w-full bg-[#fbf9ff] px-4 py-20">
          <div className="mx-auto max-w-7xl animate-pulse">
            <div className="max-w-2xl space-y-4">
              <div className="h-10 w-3/4 rounded-xl bg-[#e6dcff]"></div>
              <div className="h-10 w-1/2 rounded-xl bg-[#e6dcff]"></div>

              <div className="pt-4 space-y-3">
                <div className="h-4 w-full rounded bg-[#e6dcff]"></div>
                <div className="h-4 w-5/6 rounded bg-[#e6dcff]"></div>
                <div className="h-4 w-4/6 rounded bg-[#e6dcff]"></div>
              </div>

              <div className="flex gap-4 pt-4">
                <div className="h-12 w-40 rounded-2xl bg-[#e6dcff]"></div>
                <div className="h-12 w-40 rounded-2xl bg-[#e6dcff]"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative min-h-[560px] bg-[#211b33] px-4 py-16 md:min-h-[620px] md:py-20 lg:min-h-[680px]">
          {/* BACKGROUND IMAGE */}
          {bannerImage && (
            <img
              src={bannerImage}
              alt="Patch Collage"
              className="absolute inset-0 h-full w-full object-cover object-center"
              onError={(e) => (e.target.style.display = "none")}
            />
          )}

          {/* PROFESSIONAL OVERLAY */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#211b33]/95 via-[#211b33]/78 to-[#211b33]/25"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#211b33]/45 via-transparent to-transparent"></div>
          <div className="absolute left-0 top-0 h-full w-2/3 bg-[radial-gradient(circle_at_20%_30%,rgba(215,255,79,0.18),transparent_35%)]"></div>

          {/* CONTENT */}
          <div className="relative z-10 mx-auto flex min-h-[430px] max-w-7xl items-center md:min-h-[500px] lg:min-h-[560px]">
            <div className="max-w-2xl rounded-[28px] border border-white/15 bg-white/10 p-6 shadow-[0_25px_70px_rgba(0,0,0,0.25)] backdrop-blur-md md:p-8 lg:p-10">
              <h1 className="max-w-[900px] text-[32px] font-extrabold leading-[1.08] tracking-tight text-white sm:text-[42px] lg:text-[48px] xl:text-[54px]">
  {brandData?.settings?.banner?.header_heading || ""}
</h1>

              <p className="mt-6 max-w-xl text-base leading-8 text-[#f2ecff] md:text-lg">
                {brandData?.settings?.banner?.paragraph || ""}
              </p>

              <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                <button
                  className="rounded-2xl bg-[#d7ff4f] px-8 py-3.5 text-sm font-extrabold text-[#211b33] shadow-[0_14px_30px_rgba(215,255,79,0.32)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#c8f531]"
                  onClick={() => navigate("/products")}
                >
                  Customize Patches
                </button>

                <button
                  className="rounded-2xl border border-white/30 bg-white/12 px-8 py-3.5 text-sm font-extrabold text-white backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/20"
                  onClick={() => navigate("/products")}
                >
                  Explore Products
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;